import type { ApiLinkPreview } from '../schemas/linkPreview.schema';

import { mapLinkPreviewFromApi } from './mappers/linkPreview.mappers';
import { get } from './axios';

export const getLinkPreview = async ({ url }: { url: string }) => {
  const response = await get<{ data: ApiLinkPreview }>('/v2/link-preview', {
    query: { url },
  });
  if (!response?.data) return null;
  return mapLinkPreviewFromApi(response.data);
};
